module.exports = __webpack_public_path__ + "img/collaboration-en-ca.cb1d674c.jpg";